// extracted by mini-css-extract-plugin
export default {"confirm":"_13xxWlJ4KbE3MeCpOO6Kaz"};